import { amountToDisplayValue } from '@billy/design-system'

import { useContactBalance } from '../../../../paymentReconciliationModal/contexts'

interface UsePrepaymentModalDisplayValuesResponse {
  contactName?: string
  displayedContactBalanceAmount?: string
}

export const usePrepaymentModalDisplayValues = (): UsePrepaymentModalDisplayValuesResponse => {
  const { contact, contactBalance } = useContactBalance()

  const contactName = contact?.name
  const contactBalanceCurrencyId = contactBalance?.currencyId
  const contactBalanceAmount = contactBalance?.amount

  const displayedContactBalanceAmount = contactBalanceAmount
    ? amountToDisplayValue(contactBalanceAmount, false, contactBalanceCurrencyId)
    : undefined

  return {
    contactName,
    displayedContactBalanceAmount,
  }
}
